import { ConvertableFromApi } from "./ConvertableFromApi";
import { StorageAccountInfo } from "./StorageAccountInfo";
import { ajaxDelete } from "../data/ajax";

export class Workspace extends ConvertableFromApi<Workspace> {
  public id!: string;
  public workspaceId!: string;
  public name!: string;
  public managedBy: any;
  public tags!: Map<string, string>;
  public storageAccountInfos!: StorageAccountInfo[];
  public deleting: boolean = false;
  public subscriptionId!: string;
  public adGroupId!: string;
  public userIsOwner!: boolean
  public workspaceStatus!: string;
  public budgetStatus!: string;
  public resourceGroupName!: string;
  public budget!: number;
  public currentSpend!: number;
  public costcenter!: string;
  public budgetLastApprovedOn!: Date;
  public budgetExpirationDate!: Date;
  public ownerEmail!: string;
  public vmStatus!: string;

  constructor(data?: any) {
    super(data);

    if(!this.objectFromApi){
      return;
    }

    this.id = this.objectFromApi.id;
    this.workspaceId = this.objectFromApi.workspaceId;
    this.name = this.objectFromApi.name;
    this.managedBy = this.objectFromApi.managedBy;
    if(this.objectFromApi.tags){
      this.tags = new Map<string,string>(Object.entries(this.objectFromApi.tags));
    }
    this.subscriptionId = this.objectFromApi.subscriptionId;
    this.adGroupId = this.objectFromApi.adGroupId;
    this.storageAccountInfos = [];
    this.userIsOwner = this.objectFromApi.userIsOwner;
    this.workspaceStatus = this.objectFromApi.workspaceStatus;
    this.budgetStatus = this.objectFromApi.budgetStatus;
    this.resourceGroupName = this.objectFromApi.resourceGroupName;
    this.budget = this.objectFromApi.budget;
    this.currentSpend = this.objectFromApi.currentSpend;
    this.costcenter = this.objectFromApi.costcenter;
    this.budgetLastApprovedOn = this.objectFromApi.budgetLastApprovedOn;
    this.budgetExpirationDate = this.objectFromApi.budgetExpirationDate;
    this.ownerEmail = this.objectFromApi.ownerEmail;
    if(this.objectFromApi.storageAccountInfos){
      for (let index = 0; index < this.objectFromApi.storageAccountInfos.length; index++) {
        const element = this.objectFromApi.storageAccountInfos[index];
        this.storageAccountInfos.push(new StorageAccountInfo(element.storageAccountName, element.storageAccountTags))
      }
    }
    this.vmStatus = null;
  }

  public createNew(element: any): Workspace {
    return new Workspace(element);
  }

  public async remove(token: string) {
    const url = process.env.VUE_APP_ROOT_API + `Workspace/${this.resourceGroupName}/subscription/${this.subscriptionId}/group/${this.adGroupId}`;
    await ajaxDelete(url, token);
  }

  public setState(vmState: string) {
    this.vmStatus = vmState;
  }
}